import Parser from "@u4i/utils/Parser";

const countryParser = new Parser(country => ({
  code: country.code,
  id: country.id,
  name: country.name,
}));

export default countryParser;
